<template>
  <div class="left_block my-statistic">
    <p class="header">
      <span class="left">Моя статистика</span>
    </p>

    <form @submit.prevent="loadData" class="filter" style="display: none;">
      <b-field label="Поиск по курсам:" type="is-info" class="user_select link_input">
        <customSelect
          @input="search.course_id = $event"
          :value="search.course_id"
          placeholder="Курс"
          :keys="['id', 'name']"
          :multiple="false"
          :options="rightCoursesList"
        />
      </b-field>
      <b-field label="Поиск по статусу:" type="is-info" class="user_select link_input">
        <customSelect
          @input="search.status_id = $event"
          :value="search.status_id"
          placeholder="Статус"
          :keys="['id', 'name']"
          :multiple="false"
          :options="statusesList"
        />
      </b-field>
      <b-field label="Поиск по названию:" class="course_search input_search with_button" type="is-info">
        <b-input v-model="search.name" placeholder="Введите текст"></b-input>
        <button type="submit">Поиск</button>
      </b-field>
    </form>

    <CourseStatisticTable
      style="margin-top: 15px;"
      :is-loading="isLoading"
      :search="search"
      :statistic="statisticList"
      :total-count="statisticTotal"
      @changePage="changePage" />
  </div>
</template>

<script>
import customSelect from '@/components/ui/customSelect'
import CourseStatisticTable from '@/components/user/my-statistic/CourseStatisticTable'

export default {
  components: {
    CourseStatisticTable,
    customSelect
  },
  data() {
    return {
      search: {
        status_id: 0,
        course_id: 5,
        name: '',
        page: 1,
      },
      statusesList: [
        { id: 1, name: 'Курс начат' },
        { id: 2, name: 'Курс пройден' },
        { id: 3, name: 'Курс не пройден' },
      ],
      isLoading: false,
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    rightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    },
    statisticList() {
      return this.$store.state.courses.userStatistic.data
    },
    statisticTotal() {
      return this.$store.state.courses.userStatistic.total
    }
  },
  methods: {
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      return this.$axios2
        .get(`/users/${this.profileInfo.id}/statistic?` + qs.stringify(params))
        .then((response) => {
          this.$store.commit('setUserStatistic', { list: response.data })
        })
        .catch(this.$errorToast)
        .finally(() => this.isLoading = false);
    },
    changePage(pageNumber) {
      this.search.page = pageNumber
      this.loadData()
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>
